import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ShortId__toString_impl_wslzee3f3nb044hwkm0 as ShortId__toString_impl_wslzee } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  divkhq3vjih9fcw as div,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../theming/sections.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import {
  colored3y8uibz1hk46 as colored,
  ForegroundSemantic2og103ajpnjfv as ForegroundSemantic,
} from '../../theming/colorManagement.mjs';
import {
  xlTitle1ubqveqr3xlnc as xlTitle,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { NoHoverSemantic_getInstance1icuasw0irscx as NoHoverSemantic_getInstance } from '../../theming/appTheme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Canvas2ofr7h6unhudb as Canvas } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Canvas.commonHtml.mjs';
import {
  ProjectState_Warranty_getInstance3k7ift69kuu7o as ProjectState_Warranty_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { ProgressDelegate2saexiliay2do as ProgressDelegate } from '../ProgressDelegate.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { setClipboardText197l45mq3981x as setClipboardText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { toast3qlkoaxwmk6x7 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderProjectId(_this__u8e3s4, project) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_rem(0.15));
  view.lbb(get_centered(view), text(view, '#'));
  var tmp = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = ShortId__toString_impl_wslzee($this$reactiveScope.daj(project).y7a_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  view.lbb(get_centered(view), text(view, '-'));
  var tmp_2 = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$5 = ShortId__toString_impl_wslzee($this$reactiveScope.daj(project).w7a_1);
    this_1.set(tmp$ret$5);
    return Unit_instance;
  });
  view.hbb(p_1, view_1);
  view.lbb(tmp_2, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function header(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowCollapsingToColumn())(writer.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.bb9(get_AppDimensions().ag2_1);
  var tmp = get_lightSection(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.jba(Edges().ed0(get_AppDimensions().zg1_1, div(get_AppDimensions().zg1_1, 2)));
  view_0.bb9(get_rem(0.35));
  var tmp_0 = colored(view_0, AppColors_getInstance().mfz_1.yg9_1);
  view_0.lbb(tmp_0, xlTitle(view_0, ($this$xlTitle) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_1($this$xlTitle);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1($this$xlTitle));
    reactiveScope($this$xlTitle, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj(_this__u8e3s4.lfy()).b7b_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  }));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  var tmp_1 = view_1.kbb(get_centered(view_1), get_expanding(view_1));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl_2(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_2(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp;
    switch (_this__u8e3s4.tgj().b4_1) {
      case 0:
        tmp = $this$reactiveScope.daj(_this__u8e3s4.ygk()).d5c_1;
        break;
      case 1:
        tmp = $this$reactiveScope.daj(_this__u8e3s4.hgl()).v5i_1;
        break;
      case 2:
        tmp = $this$reactiveScope.daj(_this__u8e3s4.hgl()).v5i_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp$ret$2 = tmp;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_1, view_2);
  var tmp_4 = view_1.kbb(view_1.kbb(get_centered(view_1), view_1.jbb(SmallBodySemantic_getInstance())), view_1.jbb(NoHoverSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  view_3.gba(get_dp(3));
  renderProjectId(view_3, _this__u8e3s4.lfy());
  onClick(view_3, VOID, VOID, header$slambda_0(view_3, _this__u8e3s4));
  view_1.hbb(p_3, view_3);
  view_1.lbb(tmp_4, view_3);
  view_0.hbb(p_1, view_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_5 = get_lightSection(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.jba(Edges().ed0(get_AppDimensions().zg1_1, div(get_AppDimensions().zg1_1, 2)));
  view_4.bb9(get_rem(0.5));
  xlTitle(view_4, ($this$xlTitle) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_3($this$xlTitle);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_3($this$xlTitle));
    reactiveScope($this$xlTitle, ($this$reactiveScope) => {
      var tmp$ret$20 = $this$reactiveScope.daj(_this__u8e3s4.lfy()).u7b_1.u9b_1;
      this_0.set(tmp$ret$20);
      return Unit_instance;
    });
    dynamicTheme($this$xlTitle, ($this$dynamicTheme) => {
      var p = $this$dynamicTheme.daj(_this__u8e3s4.lfy());
      return ForegroundSemantic().cgi(Companion_getInstance().ccz(p.u7b_1.v9b_1));
    });
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.jba(Edges().cd0(get_dp(0)).id0(VOID, VOID, VOID, get_dp(1)));
  var tmp0_height = get_AppDimensions().vg1_1;
  var tmp1_width = get_rem_0(18);
  var tmp_6 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height);
  // Inline function 'com.lightningkite.kiteui.views.direct.canvas' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Canvas())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  var $this$canvas = view_6;
  var tmp_7 = KMutableProperty0();
  var tmp_8 = Canvas$_get_shown_$ref_er7zvh($this$canvas);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('shown', 0, tmp_7, tmp_8, Canvas$_set_shown_$ref_qz1lp3($this$canvas));
  reactiveScope($this$canvas, ($this$reactiveScope) => {
    var tmp$ret$22 = $this$reactiveScope.daj(_this__u8e3s4.lfy()).u7b_1.d4(ProjectState_Warranty_getInstance()) <= 0;
    this_1.set(tmp$ret$22);
    return Unit_instance;
  });
  reactive($this$canvas, ($this$reactive) => {
    $this$reactive.caj(_this__u8e3s4.lfy());
    var tmp0_safe_receiver = $this$canvas.abi_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bbi_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver();
  });
  var tmp_9 = _this__u8e3s4.lfy();
  var tmp_10 = lens(tmp_9, header$lambda);
  var tmp_11 = _this__u8e3s4.lfy();
  $this$canvas.tbi(ProgressDelegate().xga(tmp_10, lens(tmp_11, header$lambda_0)));
  view_5.hbb(p_6, view_6);
  view_5.lbb(tmp_6, view_6);
  view_4.hbb(p_5, view_5);
  view.hbb(p_4, view_4);
  view.lbb(tmp_5, view_4);
  writer.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.qgz_1.pc();
  var tmp_0 = awaitOnce($this.rgz_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  setClipboardText(tmp, tmp_0.q97());
  toast($this.qgz_1, VOID, header$slambda$lambda);
  return Unit_instance;
}
function header$slambda$lambda($this$toast) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$toast.pc());
  var tmp0_elvis_lhs = $this$toast.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$toast : tmp0_elvis_lhs;
  $this$toast.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
  view.gba(get_rem_0(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Project Reference Copied';
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.hbu(tmp_0);
  $this$toast.hbb(p, view);
  return view;
}
var header$slambdaClass;
function header$slambda() {
  if (header$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $this_header) {
        this.qgz_1 = $$this$button;
        this.rgz_1 = $this_header;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    header$slambdaClass = $;
  }
  return header$slambdaClass;
}
function header$slambda_0($$this$button, $this_header) {
  var i = new (header$slambda())($$this$button, $this_header);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Canvas$_get_shown_$ref_er7zvh(p0) {
  return () => p0.yb8();
}
function Canvas$_set_shown_$ref_qz1lp3(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function header$lambda(it) {
  return Companion_getInstance().ccz(it.u7b_1.v9b_1);
}
function header$lambda_0(it) {
  return it.u7b_1.b4_1 / ProjectState_Complete_getInstance().b4_1;
}
//region block: exports
export {
  header as header723gxwzzg7tp,
};
//endregion

//# sourceMappingURL=header.mjs.map
